import sessionStorage from '@avalara/bat-apps-shared/helpers/sessionStorage';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSalestaxDefaultText } from '../../../shared/helpers';
import conf from '../../conf';
import analytics from '../../lib/analytics';
import Banner from '../banner';
import ExternalLink from '../external-link';
import { getRenewalDate } from '../helpers/buy-flow';
import HelpCenterComponent from '../help-center';
import { ThankyouButton, ThankyouContent, ThankyouContentContainer, ThankyouPageWrapper, } from '../styled/components/buy-flow';
import { selectState } from '../../selectors';
import { getTotalCost } from '../../lib/buy-flow';
const ThankYou = () => {
    let buttonUrl = conf.CUP_URL;
    let buttonText = 'Go to AvaTax';
    const { account: { connector }, buyFlow, } = useSelector(selectState);
    const { product, selectedTier, salestax } = buyFlow;
    const quantity = (selectedTier === null || selectedTier === void 0 ? void 0 : selectedTier.quantity) || 0;
    const price = getTotalCost(buyFlow);
    useEffect(() => {
        analytics.page('PURCHASE_COMPLETE', { connector: connector.name });
    }, []);
    const referrer = sessionStorage.get('referrer');
    if (Boolean(referrer) && typeof referrer === 'string') {
        const referrerHostname = new URL(referrer).hostname;
        if (conf.AA_URL.includes(referrerHostname) || conf.INTEGRATIONS_URL.includes(referrerHostname)) {
            buttonUrl = referrer;
            buttonText = 'Begin integration setup';
        }
    }
    return React.createElement(React.Fragment, null,
        React.createElement(Banner, { backgroundImage: `${conf.ASSET_PATH}/assets/images/banner-background.png`, image: `${conf.ASSET_PATH}/assets/images/success_w.svg`, primaryText: `Thank you for purchasing ${product}` }),
        React.createElement(ThankyouPageWrapper, { id: 'buy-thank-you' },
            React.createElement(ThankyouContentContainer, { offsetRight: 50 },
                React.createElement(ThankyouContent, null,
                    React.createElement("p", null,
                        "Your account will be charged ",
                        price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
                        getSalestaxDefaultText(salestax),
                        " for ",
                        quantity,
                        " transactions",
                        connector && ` for ${connector.name}`,
                        "."),
                    React.createElement("p", null,
                        "Your plan will renew automatically on ",
                        getRenewalDate(new Date())),
                    React.createElement(ExternalLink, { "data-ref": 'buy.buyflow.thankyou.button', href: buttonUrl, title: buttonText },
                        React.createElement(ThankyouButton, { className: 'primary large' }, buttonText))),
                React.createElement(HelpCenterComponent, null))));
};
export default ThankYou;
